
// import img1 from "./1.png";
import img2 from "./2.webp";
import img3 from "./3.webp";
import img4 from "./4.webp";
import img5 from "./5.webp";


export const carouselImageSet = [
  // img1,
  img2,
  img3,
  img4,
  img5
];
